import script from "./Pagination.vue?vue&type=script&lang=tsx"
export * from "./Pagination.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__